import styled from 'styled-components'
import { rem } from 'polished'
import { useIntl } from 'react-intl'

import LoadingBox from 'components/Common/Loading/LoadingBox'
import { DetailCardAndPinLayout, DetailCardLayout } from '../DetailItemCard/common/DetailCardAndPinLayout'
import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const ImagePlaceholder = styled(LoadingBox)`
  width: 100%;
  height: ${rem(56)};
  border-radius: ${props => props.theme.borderRadius.M};

  @container (min-width: 640px) {
    height: ${rem(116)};
    border-radius: 0;
  }
`

const TextPlaceholder = styled(LoadingBox)`
  height: ${rem(20)};
`

const PinPlaceholder = styled(LoadingBox)`
  width: ${rem(20)};
  height: ${rem(20)};
  border-radius: ${props => props.theme.borderRadius.round};

  @container (min-width: 640px) {
    width: ${rem(28)};
    height: ${rem(28)};
  }
`

interface Props {
  regenerate: boolean
}

function LoadingTimelineTripItem({ regenerate }: Props) {
  const intl = useIntl()
  const findingActivityText = intl.formatMessage({
    id: 'kPfuETwpCcMPsukWbDq2',
    defaultMessage: 'Finding an activity for you…',
    description: 'Loading heading while AI finds an activity in trip planner timeline',
  })
  const replanningText = intl.formatMessage({
    id: 'DYsC4k_JVz21FGJ2KaRo',
    defaultMessage: 'Replanning your day with new ideas…',
    description: 'Loading heading while AI replans the day in trip planner timeline',
  })
  const headingText = regenerate ? replanningText : findingActivityText

  return (
    <DetailCardAndPinLayout>
      <DetailCardAndPinLayout.Pin className="pin-anchor">
        <PinPlaceholder />
      </DetailCardAndPinLayout.Pin>
      <DetailCardAndPinLayout.CardContainer>
        <DetailCardLayout.Image>
          <ImagePlaceholder />
        </DetailCardLayout.Image>
        <DetailCardLayout.Content>
          <VerticalSpacer gap={12}>
            <Heading variant="heading6">{headingText}</Heading>
            <VerticalSpacer gap={8}>
              <TextPlaceholder style={{ width: '100%' }} />
              <TextPlaceholder style={{ width: '100%' }} />
            </VerticalSpacer>
          </VerticalSpacer>
        </DetailCardLayout.Content>
      </DetailCardAndPinLayout.CardContainer>
    </DetailCardAndPinLayout>
  )
}

export default LoadingTimelineTripItem
